<template>
  <div class="map-legend">
    <div class="legend-item"><span class="dot urgent"></span> 有定金</div>
    <div class="legend-item"><span class="dot main"></span> 主推酒店</div>
    <div class="legend-item"><span class="dot normal"></span> 普通酒店</div>
  </div>
</template>

<script>
export default { name: 'MapLegend' };
</script>

<style scoped lang="scss">
@use "@/assets/styles/dashboard/map.scss";
</style>